import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useFormik, FieldArray, FormikProvider } from "formik";
import * as Yup from "yup";
import TutorSidebar from '../../../../TutorSidebar/TutorSidebar';
import HourglassLoader from '../../../../../../Common/HourglassLoader';

const TutorSubjectiveMockQuestions = () => {
    const [sessionIdCounter, setSessionIdCounter] = useState(2); // Starting ID for new questions

    // Yup Validation Schema
    const validationSchema = Yup.object().shape({
        sessions: Yup.array().of(
            Yup.object().shape({
                questionNumber: Yup.string().required("Question number is required"),
                marks: Yup.number()
                    .required("Marks are required")
                    .min(1, "Marks must be at least 1"),
            })
        ),
    });

    // Formik Setup
    const formik = useFormik({
        initialValues: {
            sessions: [
                { id: 1, questionNumber: "1", marks: "5" }, // Default first session
            ],
        },
        validationSchema,
        onSubmit: (values) => {

            alert("Test uploaded successfully!");
        },
        enableReinitialize: true,
    });

    // Add New Session
    const addSession = () => {
        formik.setFieldValue("sessions", [
            ...formik.values.sessions,
            { id: sessionIdCounter, questionNumber: sessionIdCounter.toString(), marks: "5" },
        ]);
        setSessionIdCounter(sessionIdCounter + 1);
    };

    // Delete Session
    const deleteSession = (id) => {
        const updatedSessions = formik.values.sessions.filter((session) => session.id !== id);
        formik.setFieldValue("sessions", updatedSessions);
    };
    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Add Question
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="row mb-3">
                                    <div className="col-lg-12 mb-3">
                                        <div className="card">
                                            <div className="card-body">
                                                <h5 className="mb-3">Upload Test</h5>
                                                <div className="row">
                                                    <div className="col-lg-6 col-md-6" />
                                                    <div className="col-lg-6 col-md-6 d-flex justify-content-end">
                                                        <button
                                                            type="button"
                                                            className="btn btn-success"
                                                            onClick={formik.handleSubmit}
                                                        >
                                                            Upload
                                                            <i className="fa-solid fa-upload ms-1" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Add session button */}
                                    <div className="col-lg-12 mb-3 d-flex justify-content-end">
                                        <button
                                            type="button"
                                            className="btn btn-primary add-session-btn"
                                            onClick={addSession}
                                        >
                                            <i className="fa-solid fa-plus" />
                                        </button>
                                    </div>
                                </div>

                                {/* Formik Form */}
                                <FormikProvider value={formik}>
                                    <form onSubmit={formik.handleSubmit}>
                                        <div id="session-container">
                                            <FieldArray name="sessions">
                                                {() =>
                                                    formik.values.sessions.map((session, index) => (
                                                        <div className="session mb-4" key={session.id}>
                                                            <div className="row mb-3">
                                                                <div className="col-lg-4 col-md-6 mb-3">
                                                                    <div className="card bg-light">
                                                                        <div className="card-body">
                                                                            <h6 className="mb-2">Question : {index + 1}</h6>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Enter Question Number"
                                                                                name={`sessions[${index}].questionNumber`}
                                                                                value={
                                                                                    formik.values.sessions[index].questionNumber
                                                                                }
                                                                                onChange={formik.handleChange}
                                                                            />
                                                                            {formik.errors.sessions?.[index]?.questionNumber && (
                                                                                <div className="text-danger">
                                                                                    {formik.errors.sessions[index].questionNumber}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-4 col-md-6 mb-3">
                                                                    <div className="card">
                                                                        <div className="card-body">
                                                                            <h6 className="mb-2">Marks</h6>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                placeholder="Enter Marks"
                                                                                name={`sessions[${index}].marks`}
                                                                                value={formik.values.sessions[index].marks}
                                                                                onChange={formik.handleChange}
                                                                            />
                                                                            {formik.errors.sessions?.[index]?.marks && (
                                                                                <div className="text-danger">
                                                                                    {formik.errors.sessions[index].marks}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* Delete session button */}
                                                                <div className="col-lg-4 col-md-6 mb-3 d-flex align-items-center justify-content-end">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger"
                                                                        onClick={() => deleteSession(session.id)}
                                                                    >
                                                                        <i className="fa-solid fa-trash" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </FieldArray>
                                        </div>

                                        {/* Continue Button */}
                                        <div className="row">
                                            <div className="col-lg-3">
                                                <button type="submit" disabled={formik.isSubmitting} className="btn btn-primary w-100">

                                                    {formik.isSubmitting ? <HourglassLoader /> : 'Continue'}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </FormikProvider>
                            </main>
                        </div>
                    </div>
                </div>
            </section>
            <>
                {/* Modal */}
                <div
                    className="modal fade"
                    id="adminModal"
                    tabIndex={-1}
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body my-4">
                                <img src="/assets/img/user/okay-img.png" className="img-fluid" />
                                <h4 style={{ width: "74%" }}>
                                    We will reach you after getting approval from{" "}
                                    <span className="text-primary">Admin</span>
                                </h4>
                                <Link to="/tutor/dashboard">
                                    <button type="button" className="btn btn-primary mt-4 px-4 mb-5">
                                        Okay
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        </div>
    )
}

export default TutorSubjectiveMockQuestions